import * as PropTypes from 'prop-types';
import * as React from 'react';
import RelatedArticleView from './related_article_view';

const RelatedArticlesView = ({ articles, onClick }) =>
  (
    <div className="mb-3">
      <h4 className="strong mb-half">{I18n.t('js.articles.relatedArticles.title')}</h4>
      <div className="g-container">
        {articles.map(article =>
          <RelatedArticleView key={article.id} article={article} onClick={onClick} />)}
      </div>
    </div>
  );

RelatedArticlesView.propTypes = {
  articles: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default RelatedArticlesView;



// WEBPACK FOOTER //
// ./javascripts/components/articles/related_articles_view.jsx